import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllContactAutomationsQueries } from './queries/useContactAutomationsQuery';

export function useCancelAutomationMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: (data: Api.IOperationResultNoValue) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		mutationKey: ['cancelAutomation'],
		onSuccess: data => {
			// Invalidate contact automations queries to refresh the UI
			invalidateAllContactAutomationsQueries();
			onSuccess?.(data);
		},
		onError,
		mutationFn: ({ automationId }: { automationId: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/${automationId}`,
				}),
				'DELETE'
			);
		},
	});
}
